//
//
//
//
//
//
import prowerSelect from '@/components/power/prowerSelect';
import { stationInfo, stationState, alarmToday, electricSurvey } from '@/api/admin/token';
import powerEcharts from "./powerEcharts";
export default {
  name: 'powerStatus',
  components: {
    powerEcharts: powerEcharts,
    prowerSelect: prowerSelect
  },
  data: function data() {
    return {
      onLine: 'extremum' // 用于存储选择配电站同一行显示

    };
  },
  created: function created() {
    this.stationId = sessionStorage.getItem('stationId');
  },
  mounted: function mounted() {},
  methods: {}
};